import React from 'react'
import MantineTitle from '../mantine/title';
import MantineCloseButton from '../mantine/closeButton';

const CustomModalHeaderTitle = (props: any) => {
    const { title, onClick, className } = props;
    return (
        <div>
            <MantineTitle order={3} mt={2} className={className}>{title}</MantineTitle>
            <MantineCloseButton onClick={() => onClick()} className='mt-1 absolute right-3 top-2 hover:!bg-current-territory-color hover:text-white' />
        </div>
    )
}

export default CustomModalHeaderTitle;
